import { apiZoho } from '#plugins/axios.js';

export const registerVoucher = async (data) => {
  const response = await apiZoho.post('comprobantes_catalogo', data);

  return response.data;
};

export const updateFileVoucher = async ({idVoucher, label, fileName}) => {

  const response = await apiZoho.patch(`upload_file/comprobantes_catalogo_Report/${idVoucher}`, {
    file_name: fileName,
    file: label,
  } ,{
    params: {
      fieldName: 'Comprobante',
    }
  });

  return response.data;

}